import type { ITaskStatus } from '@/types/task'

export const TASK_STATUS: { [K in ITaskStatus]: string } = {
  notStarted: 'No Iniciado',
  inProgress: 'En Curso',
  completed: 'Completado',
  inReview: 'En Revisión',
}

export const TASK_CREATION_DIALOG = {
  TITLE: 'Nueva tarea',
  CREATE: 'Crear tarea',
  NAME: 'Nombre de la tarea',
  STATUS: 'Estado',
  OWNER: 'Responsable',
  CONTROL: 'Control',
  DESCRIPTION: 'Descripción',
  NOTES: 'Notas',
  BULK_UPLOAD: 'Carga masiva',
  BULK_UPLOAD_TEMPLATE: 'Plantilla de carga masiva',
  DOCUMENT: 'Documentos',
  EVIDENCE: 'Evidencias',
  CANCEL: 'Cancelar',
}

export const TASK_TABLE = {
  TITLE: 'Lista de tareas',
  TABLE_HEADER: {
    NAME: 'Nombre',
    STATUS: 'Estado',
    OWNER: 'Responsable',
    DEADLINE: 'Fecha límite',
    CLUSTER: 'Cluster',
    CREATED_AT: 'Fecha de creación',
  },
  NO_DEADLINE: 'Sin fecha límite asignada',
  NO_CREATED_AT: 'Sin fecha de creación',
  OWNER_UPDATED: 'Responsable actualizado correctamente',
}

export const TASK_DETAILS = {
  DESCRIPTION: 'Descripción',
  STATUS: 'Estado',
  DELETED: 'Tarea eliminada correctamente',
}

export const TASK_DELETE_DIALOG = {
  QUESTION: '¿Estás seguro de que quieres eliminar esta tarea?',
  TITLE: 'Eliminar tarea',
  CANCEL: 'Cancelar',
  DELETE: 'Eliminar',
  CONFIRMATION: 'Esta acción no se puede deshacer.',
}

export const TASK_DRAWER = {
  TASK_DETAILS: 'Detalles de la tarea',
  DESCRIPTION: 'Descripción',
  ATTRIBUTES: 'Atributos',
  NOTES: 'Notas',
  DOCUMENTS: 'Documentos',
  EVIDENCES: 'Evidencias',
  TASK_UPDATED: 'Tarea actualizada',
  UPDATING: 'Actualizando tarea...',
  EVIDENCE_UPLOADS_TITLE: 'Evidencias subidas',
  ADD_LINK_BUTTON: 'Añadir enlace',
  ADD_FILE_BUTTON: 'Añadir archivo',
  NO_UPLOADS_YET: 'Sin archivos',
  UPLOAD_FILE_ARIA: 'Subir archivo',
  REMOVE_FILE_ARIA: 'Quitar',
}

export const TASK_HEADER = {
  TITLE: 'Task Manager',
  TOTAL_TASKS: 'tareas totales',
  SEARCH_PLACEHOLDER: 'Buscar tareas...',
}

export const TASK_FILTERS = {
  CLEAR_FILTERS: 'Limpiar filtros',
  CREATED_AT: 'Fecha de creación',
  DEADLINE: 'Fecha límite',
  FROM: 'Desde',
  TO: 'Hasta',
}

export const TASK_LIST_HEADER = {
  NAME: 'Nombre',
  CLUSTER: 'Cluster',
  OWNER: 'Responsable',
  CREATED_AT: 'Fecha de creación',
  DEADLINE: 'Fecha límite',
  STATUS: 'Estado',
}

export const TASK_ITEM = {
  NO_DEADLINE: 'Sin fecha límite',
  UNASSIGNED: 'Sin asignar',
}

export const TASK_ATTRIBUTES = {
  DEADLINE: 'Fecha límite',
  CREATED_AT: 'Fecha de creación',
  CONTROL: 'Control',
}

export const TASK_DESCRIPTION = {
  NO_DESCRIPTION: 'Sin descripción proporcionada',
}

export const TASK_NOTES = {
  NO_NOTES: 'Sin notas agregadas',
}

export const BULK_UPLOAD_DIALOG = {
  TITLE: 'Carga masiva de tareas',
  DESCRIPTION: 'Sube un archivo CSV o Excel para crear múltiples tareas a la vez.',
  UPLOAD_FILE: 'Subir archivo',
  UPLOADING: 'Subiendo...',
  TEMPLATE: 'Plantilla',
  CREATING_TASKS: 'Creando tareas en masa...',
  SUCCESS: 'Tareas creadas exitosamente',
  CANCEL: 'Cancelar',
}

export const CONTROL_SELECTOR = {
  SELECT_CONTROLS: 'Seleccionar controles...',
  SELECT_CONTROL: 'Seleccionar control...',
  SEARCH_CONTROLS: 'Buscar controles...',
  NO_CONTROL_FOUND: 'No se encontró ningún control.',
}

export const DOCUMENT_SELECTOR = {
  LABEL: 'Documentos',
  SELECT_DOCUMENTS: 'Seleccionar documentos...',
  NO_DOCUMENTS_AVAILABLE: 'No hay documentos disponibles',
  SEARCH_DOCUMENTS: 'Buscar documentos...',
  NO_DOCUMENT_FOUND: 'No se encontró ningún documento.',
}

export const EVIDENCE_SELECTOR = {
  LABEL: 'Evidencias',
  SELECT_EVIDENCES: 'Seleccionar evidencias...',
  NO_EVIDENCES_AVAILABLE: 'No hay evidencias disponibles',
  SEARCH_EVIDENCES: 'Buscar evidencias...',
  NO_EVIDENCE_FOUND: 'No se encontró ninguna evidencia.',
}

export const TASK_BULK_ACTIONS = {
  TASK: 'tarea',
  TASKS: 'tareas',
  SELECTED: 'seleccionadas',
  CLEAR: 'Limpiar',
  SELECT_STATUS: 'Seleccionar estado',
  OWNER_UPDATED: 'Responsable actualizado correctamente',
  STATUS_UPDATED: 'Estado actualizado correctamente',
}

export const TASK_CSV_VALIDATION = {
  NAME_REQUIRED: 'El nombre es obligatorio.',
  CONTROL_REQUIRED: 'El control es obligatorio.',
  CONTROL_NOT_FOUND: (value: string) => `Control no encontrado o inválido: "${value}".`,
  DOCUMENT_NOT_FOUND: (value: string) => `Documento no encontrado: "${value}".`,
  DOCUMENT_NOT_LINKED: (docName: string, controlName: string) =>
    `Documento "${docName}" no está asociado al control "${controlName}".`,
  EVIDENCE_NOT_FOUND: (value: string) => `Evidencia no encontrada: "${value}".`,
  EVIDENCE_NOT_LINKED: (evidenceName: string, controlName: string) =>
    `Evidencia "${evidenceName}" no está asociada al control "${controlName}".`,
  INVALID_DATE: (value: string) => `Fecha inválida: "${value}".`,
  CLUSTER_INVALID: (value: string) => `Cluster inválido: "${value}".`,
  ERRORS_HEADER: 'Se encontraron errores en el CSV. No se crearon tareas.',
  LINE_LABEL: 'Línea',
  COLUMN_LABEL: 'columna',
  ERROR_CREATING_TASKS: 'Error creando tareas',
}
